export var CLAIMING_ROUTE = '/claiming';
